(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[938],{

/***/ 27169:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": () => (/* binding */ cls$),
  "Z": () => (/* binding */ ComUI_modal)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(58509);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js
var createSuper = __webpack_require__(29388);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(71002);
// EXTERNAL MODULE: ./node_modules/rc-util/es/raf.js
var raf = __webpack_require__(75164);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Portal.js
var Portal = __webpack_require__(59015);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/canUseDom.js
var canUseDom = __webpack_require__(98924);
// EXTERNAL MODULE: ./node_modules/rc-util/es/getScrollBarSize.js
var getScrollBarSize = __webpack_require__(74204);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/setStyle.js
/**
 * Easy to set element style, return previous style
 * IE browser compatible(IE browser doesn't merge overflow style, need to set it separately)
 * https://github.com/ant-design/ant-design/issues/19393
 *
 */
function setStyle(style) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!style) {
    return {};
  }
  var _options$element = options.element,
    element = _options$element === void 0 ? document.body : _options$element;
  var oldStyle = {};
  var styleKeys = Object.keys(style);

  // IE browser compatible
  styleKeys.forEach(function (key) {
    oldStyle[key] = element.style[key];
  });
  styleKeys.forEach(function (key) {
    element.style[key] = style[key];
  });
  return oldStyle;
}
/* harmony default export */ const es_setStyle = (setStyle);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/switchScrollingEffect.js


function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var cacheStyle = {};
/* harmony default export */ const switchScrollingEffect = (function (close) {
  if (!isBodyOverflowing() && !close) {
    return;
  }

  // https://github.com/ant-design/ant-design/issues/19729
  var scrollingEffectClassName = 'ant-scrolling-effect';
  var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), 'g');
  var bodyClassName = document.body.className;
  if (close) {
    if (!scrollingEffectClassNameReg.test(bodyClassName)) return;
    es_setStyle(cacheStyle);
    cacheStyle = {};
    document.body.className = bodyClassName.replace(scrollingEffectClassNameReg, '').trim();
    return;
  }
  var scrollBarSize = (0,getScrollBarSize/* default */.Z)();
  if (scrollBarSize) {
    cacheStyle = es_setStyle({
      position: 'relative',
      width: "calc(100% - ".concat(scrollBarSize, "px)")
    });
    if (!scrollingEffectClassNameReg.test(bodyClassName)) {
      var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName);
      document.body.className = addClassName.trim();
    }
  }
});
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
;// CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/scrollLocker.js






var uuid = 0;
var locks = [];
var scrollingEffectClassName = 'ant-scrolling-effect';
var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), 'g');

// https://github.com/ant-design/ant-design/issues/19340
// https://github.com/ant-design/ant-design/issues/19332
var scrollLocker_cacheStyle = new Map();
var ScrollLocker = /*#__PURE__*/(0,createClass/* default */.Z)(function ScrollLocker(_options) {
  var _this = this;
  (0,classCallCheck/* default */.Z)(this, ScrollLocker);
  (0,defineProperty/* default */.Z)(this, "lockTarget", void 0);
  (0,defineProperty/* default */.Z)(this, "options", void 0);
  (0,defineProperty/* default */.Z)(this, "getContainer", function () {
    var _this$options;
    return (_this$options = _this.options) === null || _this$options === void 0 ? void 0 : _this$options.container;
  });
  // if options change...
  (0,defineProperty/* default */.Z)(this, "reLock", function (options) {
    var findLock = locks.find(function (_ref) {
      var target = _ref.target;
      return target === _this.lockTarget;
    });
    if (findLock) {
      _this.unLock();
    }
    _this.options = options;
    if (findLock) {
      findLock.options = options;
      _this.lock();
    }
  });
  (0,defineProperty/* default */.Z)(this, "lock", function () {
    var _this$options3;
    // If lockTarget exist return
    if (locks.some(function (_ref2) {
      var target = _ref2.target;
      return target === _this.lockTarget;
    })) {
      return;
    }

    // If same container effect, return
    if (locks.some(function (_ref3) {
      var _this$options2;
      var options = _ref3.options;
      return (options === null || options === void 0 ? void 0 : options.container) === ((_this$options2 = _this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.container);
    })) {
      locks = [].concat((0,toConsumableArray/* default */.Z)(locks), [{
        target: _this.lockTarget,
        options: _this.options
      }]);
      return;
    }
    var scrollBarSize = 0;
    var container = ((_this$options3 = _this.options) === null || _this$options3 === void 0 ? void 0 : _this$options3.container) || document.body;
    if (container === document.body && window.innerWidth - document.documentElement.clientWidth > 0 || container.scrollHeight > container.clientHeight) {
      if (getComputedStyle(container).overflow !== 'hidden') {
        scrollBarSize = (0,getScrollBarSize/* default */.Z)();
      }
    }
    var containerClassName = container.className;
    if (locks.filter(function (_ref4) {
      var _this$options4;
      var options = _ref4.options;
      return (options === null || options === void 0 ? void 0 : options.container) === ((_this$options4 = _this.options) === null || _this$options4 === void 0 ? void 0 : _this$options4.container);
    }).length === 0) {
      scrollLocker_cacheStyle.set(container, es_setStyle({
        width: scrollBarSize !== 0 ? "calc(100% - ".concat(scrollBarSize, "px)") : undefined,
        overflow: 'hidden',
        overflowX: 'hidden',
        overflowY: 'hidden'
      }, {
        element: container
      }));
    }

    // https://github.com/ant-design/ant-design/issues/19729
    if (!scrollingEffectClassNameReg.test(containerClassName)) {
      var addClassName = "".concat(containerClassName, " ").concat(scrollingEffectClassName);
      container.className = addClassName.trim();
    }
    locks = [].concat((0,toConsumableArray/* default */.Z)(locks), [{
      target: _this.lockTarget,
      options: _this.options
    }]);
  });
  (0,defineProperty/* default */.Z)(this, "unLock", function () {
    var _this$options5;
    var findLock = locks.find(function (_ref5) {
      var target = _ref5.target;
      return target === _this.lockTarget;
    });
    locks = locks.filter(function (_ref6) {
      var target = _ref6.target;
      return target !== _this.lockTarget;
    });
    if (!findLock || locks.some(function (_ref7) {
      var _findLock$options;
      var options = _ref7.options;
      return (options === null || options === void 0 ? void 0 : options.container) === ((_findLock$options = findLock.options) === null || _findLock$options === void 0 ? void 0 : _findLock$options.container);
    })) {
      return;
    }

    // Remove Effect
    var container = ((_this$options5 = _this.options) === null || _this$options5 === void 0 ? void 0 : _this$options5.container) || document.body;
    var containerClassName = container.className;
    if (!scrollingEffectClassNameReg.test(containerClassName)) return;
    es_setStyle(scrollLocker_cacheStyle.get(container), {
      element: container
    });
    scrollLocker_cacheStyle.delete(container);
    container.className = container.className.replace(scrollingEffectClassNameReg, '').trim();
  });
  // eslint-disable-next-line no-plusplus
  this.lockTarget = uuid++;
  this.options = _options;
});

;// CONCATENATED MODULE: ./node_modules/rc-util/es/PortalWrapper.js







/* eslint-disable no-underscore-dangle,react/require-default-props */







var openCount = 0;
var supportDom = (0,canUseDom/* default */.Z)();

/** @private Test usage only */
function getOpenCount() {
  return  false ? 0 : 0;
}

// https://github.com/ant-design/ant-design/issues/19340
// https://github.com/ant-design/ant-design/issues/19332
var cacheOverflow = {};
var getParent = function getParent(getContainer) {
  if (!supportDom) {
    return null;
  }
  if (getContainer) {
    if (typeof getContainer === 'string') {
      return document.querySelectorAll(getContainer)[0];
    }
    if (typeof getContainer === 'function') {
      return getContainer();
    }
    if ((0,esm_typeof/* default */.Z)(getContainer) === 'object' && getContainer instanceof window.HTMLElement) {
      return getContainer;
    }
  }
  return document.body;
};
var PortalWrapper = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(PortalWrapper, _React$Component);
  var _super = (0,createSuper/* default */.Z)(PortalWrapper);
  function PortalWrapper(props) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, PortalWrapper);
    _this = _super.call(this, props);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "container", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "componentRef", /*#__PURE__*/react.createRef());
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "rafId", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "scrollLocker", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "renderComponent", void 0);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "updateScrollLocker", function (prevProps) {
      var _ref = prevProps || {},
        prevVisible = _ref.visible;
      var _this$props = _this.props,
        getContainer = _this$props.getContainer,
        visible = _this$props.visible;
      if (visible && visible !== prevVisible && supportDom && getParent(getContainer) !== _this.scrollLocker.getContainer()) {
        _this.scrollLocker.reLock({
          container: getParent(getContainer)
        });
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "updateOpenCount", function (prevProps) {
      var _ref2 = prevProps || {},
        prevVisible = _ref2.visible,
        prevGetContainer = _ref2.getContainer;
      var _this$props2 = _this.props,
        visible = _this$props2.visible,
        getContainer = _this$props2.getContainer;

      // Update count
      if (visible !== prevVisible && supportDom && getParent(getContainer) === document.body) {
        if (visible && !prevVisible) {
          openCount += 1;
        } else if (prevProps) {
          openCount -= 1;
        }
      }

      // Clean up container if needed
      var getContainerIsFunc = typeof getContainer === 'function' && typeof prevGetContainer === 'function';
      if (getContainerIsFunc ? getContainer.toString() !== prevGetContainer.toString() : getContainer !== prevGetContainer) {
        _this.removeCurrentContainer();
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "attachToParent", function () {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (force || _this.container && !_this.container.parentNode) {
        var parent = getParent(_this.props.getContainer);
        if (parent) {
          parent.appendChild(_this.container);
          return true;
        }
        return false;
      }
      return true;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getContainer", function () {
      if (!supportDom) {
        return null;
      }
      if (!_this.container) {
        _this.container = document.createElement('div');
        _this.attachToParent(true);
      }
      _this.setWrapperClassName();
      return _this.container;
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "setWrapperClassName", function () {
      var wrapperClassName = _this.props.wrapperClassName;
      if (_this.container && wrapperClassName && wrapperClassName !== _this.container.className) {
        _this.container.className = wrapperClassName;
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "removeCurrentContainer", function () {
      var _this$container;
      // Portal will remove from `parentNode`.
      // Let's handle this again to avoid refactor issue.
      (_this$container = _this.container) === null || _this$container === void 0 || (_this$container = _this$container.parentNode) === null || _this$container === void 0 || _this$container.removeChild(_this.container);
    });
    /**
     * Enhance ./switchScrollingEffect
     * 1. Simulate document body scroll bar with
     * 2. Record body has overflow style and recover when all of PortalWrapper invisible
     * 3. Disable body scroll when PortalWrapper has open
     *
     * @memberof PortalWrapper
     */
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "switchScrollingEffect", function () {
      if (openCount === 1 && !Object.keys(cacheOverflow).length) {
        switchScrollingEffect();
        // Must be set after switchScrollingEffect
        cacheOverflow = es_setStyle({
          overflow: 'hidden',
          overflowX: 'hidden',
          overflowY: 'hidden'
        });
      } else if (!openCount) {
        es_setStyle(cacheOverflow);
        cacheOverflow = {};
        switchScrollingEffect(true);
      }
    });
    _this.scrollLocker = new ScrollLocker({
      container: getParent(props.getContainer)
    });
    return _this;
  }
  (0,createClass/* default */.Z)(PortalWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.updateOpenCount();
      if (!this.attachToParent()) {
        this.rafId = (0,raf/* default */.Z)(function () {
          _this2.forceUpdate();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.updateOpenCount(prevProps);
      this.updateScrollLocker(prevProps);
      this.setWrapperClassName();
      this.attachToParent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
        visible = _this$props3.visible,
        getContainer = _this$props3.getContainer;
      if (supportDom && getParent(getContainer) === document.body) {
        // 离开时不会 render， 导到离开时数值不变，改用 func 。。
        openCount = visible && openCount ? openCount - 1 : openCount;
      }
      this.removeCurrentContainer();
      raf/* default.cancel */.Z.cancel(this.rafId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        children = _this$props4.children,
        forceRender = _this$props4.forceRender,
        visible = _this$props4.visible;
      var portal = null;
      var childProps = {
        getOpenCount: function getOpenCount() {
          return openCount;
        },
        getContainer: this.getContainer,
        switchScrollingEffect: this.switchScrollingEffect,
        scrollLocker: this.scrollLocker
      };
      if (forceRender || visible || this.componentRef.current) {
        portal = /*#__PURE__*/react.createElement(Portal/* default */.Z, {
          getContainer: this.getContainer,
          ref: this.componentRef
        }, children(childProps));
      }
      return portal;
    }
  }]);
  return PortalWrapper;
}(react.Component);
/* harmony default export */ const es_PortalWrapper = (PortalWrapper);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(15105);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useId.js
var useId = __webpack_require__(7028);
// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/contains.js
var contains = __webpack_require__(94999);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(64217);
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var es = __webpack_require__(29372);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog/Mask.js





function Mask(props) {
  var prefixCls = props.prefixCls,
      style = props.style,
      visible = props.visible,
      maskProps = props.maskProps,
      motionName = props.motionName;
  return /*#__PURE__*/react.createElement(es/* default */.ZP, {
    key: "mask",
    visible: visible,
    motionName: motionName,
    leavedClassName: "".concat(prefixCls, "-mask-hidden")
  }, function (_ref) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, motionStyle), style),
      className: classnames_default()("".concat(prefixCls, "-mask"), motionClassName)
    }, maskProps));
  });
}
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/util.js
// =============================== Motion ===============================
function getMotionName(prefixCls, transitionName, animationName) {
  var motionName = transitionName;

  if (!motionName && animationName) {
    motionName = "".concat(prefixCls, "-").concat(animationName);
  }

  return motionName;
} // =============================== Offset ===============================

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document;
    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      ret = d.body[method];
    }
  }

  return ret;
}

function offset(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, true);
  return pos;
}
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog/Content/MemoChildren.js

/* harmony default export */ const MemoChildren = (/*#__PURE__*/react.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (_, _ref2) {
  var shouldUpdate = _ref2.shouldUpdate;
  return !shouldUpdate;
}));
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog/Content/Panel.js





var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: 'hidden',
  outline: 'none'
};
var Panel = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      title = props.title,
      ariaId = props.ariaId,
      footer = props.footer,
      closable = props.closable,
      closeIcon = props.closeIcon,
      onClose = props.onClose,
      children = props.children,
      bodyStyle = props.bodyStyle,
      bodyProps = props.bodyProps,
      modalRender = props.modalRender,
      onMouseDown = props.onMouseDown,
      onMouseUp = props.onMouseUp,
      holderRef = props.holderRef,
      visible = props.visible,
      forceRender = props.forceRender,
      width = props.width,
      height = props.height; // ================================= Refs =================================

  var sentinelStartRef = (0,react.useRef)();
  var sentinelEndRef = (0,react.useRef)();
  react.useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        var _sentinelStartRef$cur;

        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 ? void 0 : _sentinelStartRef$cur.focus();
      },
      changeActive: function changeActive(next) {
        var _document = document,
            activeElement = _document.activeElement;

        if (next && activeElement === sentinelEndRef.current) {
          sentinelStartRef.current.focus();
        } else if (!next && activeElement === sentinelStartRef.current) {
          sentinelEndRef.current.focus();
        }
      }
    };
  }); // ================================ Style =================================

  var contentStyle = {};

  if (width !== undefined) {
    contentStyle.width = width;
  }

  if (height !== undefined) {
    contentStyle.height = height;
  } // ================================ Render ================================


  var footerNode;

  if (footer) {
    footerNode = /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-footer")
    }, footer);
  }

  var headerNode;

  if (title) {
    headerNode = /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-header")
    }, /*#__PURE__*/react.createElement("div", {
      className: "".concat(prefixCls, "-title"),
      id: ariaId
    }, title));
  }

  var closer;

  if (closable) {
    closer = /*#__PURE__*/react.createElement("button", {
      type: "button",
      onClick: onClose,
      "aria-label": "Close",
      className: "".concat(prefixCls, "-close")
    }, closeIcon || /*#__PURE__*/react.createElement("span", {
      className: "".concat(prefixCls, "-close-x")
    }));
  }

  var content = /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-content")
  }, closer, headerNode, /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle
  }, bodyProps), children), footerNode);
  return /*#__PURE__*/react.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": title ? ariaId : null,
    "aria-modal": "true",
    ref: holderRef,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, style), contentStyle),
    className: classnames_default()(prefixCls, className),
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp
  }, /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    ref: sentinelStartRef,
    style: sentinelStyle,
    "aria-hidden": "true"
  }), /*#__PURE__*/react.createElement(MemoChildren, {
    shouldUpdate: visible || forceRender
  }, modalRender ? modalRender(content) : content), /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    ref: sentinelEndRef,
    style: sentinelStyle,
    "aria-hidden": "true"
  }));
});

if (false) {}

/* harmony default export */ const Content_Panel = (Panel);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog/Content/index.js









var Content = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
      title = props.title,
      style = props.style,
      className = props.className,
      visible = props.visible,
      forceRender = props.forceRender,
      destroyOnClose = props.destroyOnClose,
      motionName = props.motionName,
      ariaId = props.ariaId,
      onVisibleChanged = props.onVisibleChanged,
      mousePosition = props.mousePosition;
  var dialogRef = (0,react.useRef)(); // ============================= Style ==============================

  var _React$useState = react.useState(),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      transformOrigin = _React$useState2[0],
      setTransformOrigin = _React$useState2[1];

  var contentStyle = {};

  if (transformOrigin) {
    contentStyle.transformOrigin = transformOrigin;
  }

  function onPrepare() {
    var elementOffset = offset(dialogRef.current);
    setTransformOrigin(mousePosition ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : '');
  } // ============================= Render =============================


  return /*#__PURE__*/react.createElement(es/* default */.ZP, {
    visible: visible,
    onVisibleChanged: onVisibleChanged,
    onAppearPrepare: onPrepare,
    onEnterPrepare: onPrepare,
    forceRender: forceRender,
    motionName: motionName,
    removeOnLeave: destroyOnClose,
    ref: dialogRef
  }, function (_ref, motionRef) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    return /*#__PURE__*/react.createElement(Content_Panel, (0,esm_extends/* default */.Z)({}, props, {
      ref: ref,
      title: title,
      ariaId: ariaId,
      prefixCls: prefixCls,
      holderRef: motionRef,
      style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, motionStyle), style), contentStyle),
      className: classnames_default()(className, motionClassName)
    }));
  });
});
Content.displayName = 'Content';
/* harmony default export */ const Dialog_Content = (Content);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/Dialog/index.js













function Dialog(props) {
  var _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-dialog' : _props$prefixCls,
      zIndex = props.zIndex,
      _props$visible = props.visible,
      visible = _props$visible === void 0 ? false : _props$visible,
      _props$keyboard = props.keyboard,
      keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
      _props$focusTriggerAf = props.focusTriggerAfterClose,
      focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf,
      scrollLocker = props.scrollLocker,
      wrapStyle = props.wrapStyle,
      wrapClassName = props.wrapClassName,
      wrapProps = props.wrapProps,
      onClose = props.onClose,
      afterClose = props.afterClose,
      transitionName = props.transitionName,
      animation = props.animation,
      _props$closable = props.closable,
      closable = _props$closable === void 0 ? true : _props$closable,
      _props$mask = props.mask,
      mask = _props$mask === void 0 ? true : _props$mask,
      maskTransitionName = props.maskTransitionName,
      maskAnimation = props.maskAnimation,
      _props$maskClosable = props.maskClosable,
      maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable,
      maskStyle = props.maskStyle,
      maskProps = props.maskProps,
      rootClassName = props.rootClassName;
  var lastOutSideActiveElementRef = (0,react.useRef)();
  var wrapperRef = (0,react.useRef)();
  var contentRef = (0,react.useRef)();

  var _React$useState = react.useState(visible),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      animatedVisible = _React$useState2[0],
      setAnimatedVisible = _React$useState2[1]; // ========================== Init ==========================


  var ariaId = (0,useId/* default */.Z)(); // ========================= Events =========================

  function onDialogVisibleChanged(newVisible) {
    if (newVisible) {
      // Try to focus
      if (!(0,contains/* default */.Z)(wrapperRef.current, document.activeElement)) {
        var _contentRef$current;

        lastOutSideActiveElementRef.current = document.activeElement;
        (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.focus();
      }
    } else {
      // Clean up scroll bar & focus back
      setAnimatedVisible(false);

      if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
        try {
          lastOutSideActiveElementRef.current.focus({
            preventScroll: true
          });
        } catch (e) {// Do nothing
        }

        lastOutSideActiveElementRef.current = null;
      } // Trigger afterClose only when change visible from true to false


      if (animatedVisible) {
        afterClose === null || afterClose === void 0 ? void 0 : afterClose();
      }
    }
  }

  function onInternalClose(e) {
    onClose === null || onClose === void 0 ? void 0 : onClose(e);
  } // >>> Content


  var contentClickRef = (0,react.useRef)(false);
  var contentTimeoutRef = (0,react.useRef)(); // We need record content click incase content popup out of dialog

  var onContentMouseDown = function onContentMouseDown() {
    clearTimeout(contentTimeoutRef.current);
    contentClickRef.current = true;
  };

  var onContentMouseUp = function onContentMouseUp() {
    contentTimeoutRef.current = setTimeout(function () {
      contentClickRef.current = false;
    });
  }; // >>> Wrapper
  // Close only when element not on dialog


  var onWrapperClick = null;

  if (maskClosable) {
    onWrapperClick = function onWrapperClick(e) {
      if (contentClickRef.current) {
        contentClickRef.current = false;
      } else if (wrapperRef.current === e.target) {
        onInternalClose(e);
      }
    };
  }

  function onWrapperKeyDown(e) {
    if (keyboard && e.keyCode === KeyCode/* default.ESC */.Z.ESC) {
      e.stopPropagation();
      onInternalClose(e);
      return;
    } // keep focus inside dialog


    if (visible) {
      if (e.keyCode === KeyCode/* default.TAB */.Z.TAB) {
        contentRef.current.changeActive(!e.shiftKey);
      }
    }
  } // ========================= Effect =========================


  (0,react.useEffect)(function () {
    if (visible) {
      setAnimatedVisible(true);
    }

    return function () {};
  }, [visible]); // Remove direct should also check the scroll bar update

  (0,react.useEffect)(function () {
    return function () {
      clearTimeout(contentTimeoutRef.current);
    };
  }, []);
  (0,react.useEffect)(function () {
    if (animatedVisible) {
      scrollLocker === null || scrollLocker === void 0 ? void 0 : scrollLocker.lock();
      return scrollLocker === null || scrollLocker === void 0 ? void 0 : scrollLocker.unLock;
    }

    return function () {};
  }, [animatedVisible, scrollLocker]); // ========================= Render =========================

  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    className: classnames_default()("".concat(prefixCls, "-root"), rootClassName)
  }, (0,pickAttrs/* default */.Z)(props, {
    data: true
  })), /*#__PURE__*/react.createElement(Mask, {
    prefixCls: prefixCls,
    visible: mask && visible,
    motionName: getMotionName(prefixCls, maskTransitionName, maskAnimation),
    style: (0,objectSpread2/* default */.Z)({
      zIndex: zIndex
    }, maskStyle),
    maskProps: maskProps
  }), /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({
    tabIndex: -1,
    onKeyDown: onWrapperKeyDown,
    className: classnames_default()("".concat(prefixCls, "-wrap"), wrapClassName),
    ref: wrapperRef,
    onClick: onWrapperClick,
    style: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({
      zIndex: zIndex
    }, wrapStyle), {}, {
      display: !animatedVisible ? 'none' : null
    })
  }, wrapProps), /*#__PURE__*/react.createElement(Dialog_Content, (0,esm_extends/* default */.Z)({}, props, {
    onMouseDown: onContentMouseDown,
    onMouseUp: onContentMouseUp,
    ref: contentRef,
    closable: closable,
    ariaId: ariaId,
    prefixCls: prefixCls,
    visible: visible,
    onClose: onInternalClose,
    onVisibleChanged: onDialogVisibleChanged,
    motionName: getMotionName(prefixCls, transitionName, animation)
  }))));
}
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/DialogWrap.js




 // fix issue #10656

/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */

var DialogWrap = function DialogWrap(props) {
  var visible = props.visible,
      getContainer = props.getContainer,
      forceRender = props.forceRender,
      _props$destroyOnClose = props.destroyOnClose,
      destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose,
      _afterClose = props.afterClose;

  var _React$useState = react.useState(visible),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      animatedVisible = _React$useState2[0],
      setAnimatedVisible = _React$useState2[1];

  react.useEffect(function () {
    if (visible) {
      setAnimatedVisible(true);
    }
  }, [visible]); // 渲染在当前 dom 里；

  if (getContainer === false) {
    return /*#__PURE__*/react.createElement(Dialog, (0,esm_extends/* default */.Z)({}, props, {
      getOpenCount: function getOpenCount() {
        return 2;
      } // 不对 body 做任何操作。。

    }));
  } // Destroy on close will remove wrapped div


  if (!forceRender && destroyOnClose && !animatedVisible) {
    return null;
  }

  return /*#__PURE__*/react.createElement(es_PortalWrapper, {
    visible: visible,
    forceRender: forceRender,
    getContainer: getContainer
  }, function (childProps) {
    return /*#__PURE__*/react.createElement(Dialog, (0,esm_extends/* default */.Z)({}, props, {
      destroyOnClose: destroyOnClose,
      afterClose: function afterClose() {
        _afterClose === null || _afterClose === void 0 ? void 0 : _afterClose();
        setAnimatedVisible(false);
      }
    }, childProps));
  });
};

DialogWrap.displayName = 'Dialog';
/* harmony default export */ const es_DialogWrap = (DialogWrap);
;// CONCATENATED MODULE: ./node_modules/rc-dialog/es/index.js



/* harmony default export */ const rc_dialog_es = (es_DialogWrap);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/cls.js
var cls = __webpack_require__(51811);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/React/render.js
var render = __webpack_require__(24996);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/modal/alert.js
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint-disable @typescript-eslint/no-empty-function */ 



var closest = function closest(el, selector) {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    var p = el;
    while(p){
        if (matchesSelector.call(p, selector)) {
            return p;
        }
        p = p.parentElement;
    }
    return null;
};
var alert_alert = function alert(_ref) {
    var _actionProps$actions;
    var title = _ref.title, message = _ref.message, _ref$actionProps = _ref.actionProps, actionProps = _ref$actionProps === void 0 ? {
        actions: [
            {
                text: "确定"
            }
        ],
        direction: "row"
    } : _ref$actionProps, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, style = _ref.style, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 999 : _ref$zIndex, closable = _ref.closable, closeIcon = _ref.closeIcon, footer = _ref.footer, iconFontProps = _ref.iconFontProps, _onClose = _ref.onClose;
    // ssr
    if (false) {}
    var closed = false;
    if (!title && !message) {
        throw new Error("Must specify either an alert title, or message, or both");
    // return { close: () => {} };
    }
    var div = document.createElement("div");
    document.body.appendChild(div);
    var close = function close() {
        (0,render/* unmount */.vE)(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    };
    var actions = actionProps === null || actionProps === void 0 ? void 0 : (_actionProps$actions = actionProps.actions) === null || _actionProps$actions === void 0 ? void 0 : _actionProps$actions.map(function(button) {
        var orginPress = button.onPress || function() {};
        var canDoPromise = true;
        button.onPress = function() {
            if (closed) {
                return;
            }
            if (!canDoPromise) return;
            var res = orginPress();
            if (res !== null && res !== void 0 && res.then) {
                canDoPromise = false;
                res.then(function() {
                    closed = true;
                    close();
                }).catch(function() {}).finally(function() {
                    return canDoPromise = true;
                });
            } else {
                closed = true;
                close();
            }
        };
        button.closeModal = function() {
            closed = true;
            close();
        };
        return button;
    });
    var onWrapTouchStart = function onWrapTouchStart(e) {
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = closest(e.target, ".".concat(cls$("footer")));
        if (!pNode) {
            e.preventDefault();
        }
    };
    // 兼容react18的waring
    (0,render/* render */.sY)(/*#__PURE__*/ react.createElement(ComUI_modal, {
        className: classnames_default()(_defineProperty({}, cls$("only-title"), !message), className),
        visible: true,
        onClose: function onClose() {
            _onClose === null || _onClose === void 0 ? void 0 : _onClose();
            close();
        },
        transparent: true,
        title: title,
        transitionName: "am-zoom",
        closable: closable,
        closeIcon: closeIcon,
        maskClosable: false,
        actionProps: _objectSpread(_objectSpread({}, actionProps), {}, {
            actions: actions
        }),
        maskTransitionName: "am-fade",
        wrapProps: {
            onTouchStart: onWrapTouchStart
        },
        style: style,
        zIndex: zIndex,
        footer: footer,
        iconFontProps: iconFontProps
    }, /*#__PURE__*/ react.createElement("div", {
        className: cls$("alert-content")
    }, message)), div);
    return {
        close: close
    };
};
/* harmony default export */ const modal_alert = (alert_alert);

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/modal/index.less
var modal = __webpack_require__(41004);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/modal/index.js
function modal_typeof(obj) {
    "@babel/helpers - typeof";
    return modal_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, modal_typeof(obj);
}
var _excluded = [
    "className",
    "style",
    "wrapClassName",
    "actionProps",
    "transparent",
    "maskTransitionName",
    "popup",
    "animationType",
    "animated",
    "transitionName",
    "zIndex",
    "title",
    "closable",
    "closeIcon",
    "footer",
    "iconFontProps"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function modal_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function modal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? modal_ownKeys(Object(source), !0).forEach(function(key) {
            modal_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : modal_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function modal_defineProperty(obj, key, value) {
    key = modal_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function modal_toPropertyKey(arg) {
    var key = modal_toPrimitive(arg, "string");
    return modal_typeof(key) === "symbol" ? key : String(key);
}
function modal_toPrimitive(input, hint) {
    if (modal_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (modal_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var subPrefix = "Modal";
var cls$ = (0,cls/* default */.ZP)(subPrefix);
var defaultIconFontProps = {
    className: cls$("info-icon"),
    name: "InfoCircleFill",
    fontSize: 54,
    color: "var(--content-system-info-icon-regular, rgba(140, 192, 255, 100%))"
};
var Modal = function Modal(_ref) {
    var className = _ref.className, style = _ref.style, wrapClassName = _ref.wrapClassName, actionProps = _ref.actionProps, _ref$transparent = _ref.transparent, transparent = _ref$transparent === void 0 ? false : _ref$transparent, maskTransitionName = _ref.maskTransitionName, _ref$popup = _ref.popup, popup = _ref$popup === void 0 ? false : _ref$popup, _ref$animationType = _ref.animationType, animationType = _ref$animationType === void 0 ? "slide-down" : _ref$animationType, _ref$animated = _ref.animated, animated = _ref$animated === void 0 ? true : _ref$animated, transitionName = _ref.transitionName, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 999 : _ref$zIndex, title = _ref.title, _ref$closable = _ref.closable, closable = _ref$closable === void 0 ? true : _ref$closable, closeIcon = _ref.closeIcon, footer = _ref.footer, userIconFontProps = _ref.iconFontProps, restProps = _objectWithoutProperties(_ref, _excluded);
    var _ref2 = actionProps !== null && actionProps !== void 0 ? actionProps : {}, _ref2$actions = _ref2.actions, actions = _ref2$actions === void 0 ? [] : _ref2$actions, _ref2$direction = _ref2.direction, actionsDirection = _ref2$direction === void 0 ? "row" : _ref2$direction;
    var iconFontProps = modal_objectSpread(modal_objectSpread(modal_objectSpread({}, defaultIconFontProps), userIconFontProps), {}, {
        className: classnames_default()(defaultIconFontProps.className, userIconFontProps === null || userIconFontProps === void 0 ? void 0 : userIconFontProps.className)
    });
    var renderFooterButton = function renderFooterButton(action) {
        var _action$style;
        return /*#__PURE__*/ react.createElement("button", {
            className: cls$("button"),
            role: "button",
            type: "button",
            onClick: function onClick(e) {
                e.preventDefault();
                if (action.onPress) {
                    action.onPress();
                }
            },
            style: (_action$style = action.style) !== null && _action$style !== void 0 ? _action$style : {}
        }, action.text);
    };
    var footerDom = footer !== null && footer !== void 0 ? footer : actions.length ? /*#__PURE__*/ react.createElement("div", {
        className: cls$("button-direction-".concat(actionsDirection), {
            "only-button": actions.length === 1
        }),
        role: "group"
    }, actions.map(function(button) {
        return renderFooterButton(button);
    })) : null;
    var transName;
    var maskTransName;
    if (animated) {
        // tslint:disable-next-line:prefer-conditional-expression
        if (transparent) {
            transName = maskTransName = "am-fade";
        } else {
            transName = maskTransName = "am-slide-up";
        }
        if (popup) {
            transName = animationType === "slide-up" ? "am-slide-up" : "am-slide-down";
            maskTransName = "am-fade";
        }
    }
    (0,react.useEffect)(function() {
        (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)(document.body, {
            reserveScrollBarGap: true
        });
        return function() {
            return (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(document.body);
        };
    }, []);
    var defaultCloseIconNode = /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "CrossBlack",
        color: "var(--content-system-tertiary)",
        fontSize: 14
    });
    return /*#__PURE__*/ react.createElement(rc_dialog_es, _extends({}, restProps, {
        prefixCls: cls$(),
        className: classnames_default()(className, cls$(modal_defineProperty({
            transparent: transparent,
            popup: popup
        }, "popup-".concat(animationType), popup && animationType))),
        closable: closable,
        closeIcon: closeIcon === null || closeIcon === false ? null : defaultCloseIconNode,
        wrapClassName: classnames_default()(wrapClassName, modal_defineProperty({}, cls$("wrap-popup"), popup)),
        transitionName: transitionName || transName,
        maskTransitionName: maskTransitionName || maskTransName,
        style: modal_objectSpread({
            // @ts-ignore
            "--zindex": zIndex
        }, style),
        title: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, iconFontProps), /*#__PURE__*/ react.createElement("div", {
            className: cls$("real-title")
        }, title)),
        footer: footerDom,
        zIndex: zIndex
    }));
};
Modal.alert = modal_alert;
/* harmony default export */ const ComUI_modal = (Modal);


/***/ }),

/***/ 69868:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _ComUI_commonModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40451);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74107);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58322);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_1__);




/**
 * 身份切换后的确认弹窗
 */ var ConfirmModal = function ConfirmModal(props) {
    var description = props.description, onOk = props.onOk;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ComUI_commonModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        destroyOnClose: true,
        open: true,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "xdesign-team-confirm-modal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "xdesign-team-confirm-modal__body"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "xdesign-team-confirm-modal__tip"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        fontSize: 54,
        name: "InfoCircleFill",
        color: "var(--content-system-info-icon-regular,#8cc0ff)"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "xdesign-team-confirm-modal__title"
    }, "您的身份已被切换"), description ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "xdesign-team-confirm-modal__description"
    }, description) : null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "xdesign-team-confirm-modal__btn",
        onClick: onOk
    }, "确定")));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(ConfirmModal));


/***/ }),

/***/ 56157:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uL": () => (/* binding */ InviteModalAfterReload),
  "WM": () => (/* binding */ openInviteModal),
  "ce": () => (/* binding */ useOpenInviteModalFromQuery)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/modal/index.js + 13 modules
var modal = __webpack_require__(27169);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/commonModal/index.js
var commonModal = __webpack_require__(40451);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/message/index.js
var message = __webpack_require__(20134);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var teamInfo = __webpack_require__(32485);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/share/utils/index.js
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

/** 获取带文案的分享链接 */ var getSharedUrlWidthText = function getSharedUrlWidthText(_ref) {
    var _urlMap;
    var shareUrl = _ref.shareUrl, name = _ref.name, type = _ref.type;
    var NAME_LENGTH = 8;
    var sliceName = name.length > NAME_LENGTH ? (name === null || name === void 0 ? void 0 : name.slice(0, NAME_LENGTH)) + "..." : name;
    var urlMap = (_urlMap = {}, _defineProperty(_urlMap, teamInfo/* TeamShareNodeType.RECORD */.iJ.RECORD, "".concat(shareUrl, "#我分享了【").concat(sliceName, "】，点击查看")), _defineProperty(_urlMap, teamInfo/* TeamShareNodeType.TEMPLATE */.iJ.TEMPLATE, "".concat(shareUrl, "#我分享了【").concat(sliceName, "】，点击查看")), _defineProperty(_urlMap, teamInfo/* TeamShareNodeType.FOLDER */.iJ.FOLDER, "".concat(shareUrl, "#我分享了【").concat(sliceName, "】，点击查看")), _defineProperty(_urlMap, "invite", "".concat(shareUrl, "#我邀请你加入【").concat(sliceName, "】，点击加入")), _defineProperty(_urlMap, "applyVisit", "".concat(shareUrl, "#我请求访问【").concat(sliceName, "】，点击处理申请")), _defineProperty(_urlMap, "applyEdit", "".concat(shareUrl, "#我请求编辑【").concat(sliceName, "】，点击处理申请")), _urlMap);
    return urlMap[type];
};

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/url.js
var url = __webpack_require__(86984);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-modal-open/dist/createModalComponent.js + 1 modules
var createModalComponent = __webpack_require__(69289);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var dist_teamInfo = __webpack_require__(46718);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/api/index.js + 1 modules
var api = __webpack_require__(37057);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/usePermissions.js
var usePermissions = __webpack_require__(90076);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/utils/index.js + 35 modules
var utils = __webpack_require__(35601);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/inviteModal/index.less
var inviteModal = __webpack_require__(21385);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/inviteModal/index.js
function inviteModal_typeof(obj) {
    "@babel/helpers - typeof";
    return inviteModal_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, inviteModal_typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, inviteModal_toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            inviteModal_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function inviteModal_defineProperty(obj, key, value) {
    key = inviteModal_toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function inviteModal_toPropertyKey(arg) {
    var key = inviteModal_toPrimitive(arg, "string");
    return inviteModal_typeof(key) === "symbol" ? key : String(key);
}
function inviteModal_toPrimitive(input, hint) {
    if (inviteModal_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (inviteModal_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}













/** 有效期配置 */ var expiredConfig = [
    {
        label: "7天",
        value: 7
    },
    {
        label: "30天",
        value: 30
    },
    {
        label: "永久",
        alias: "永久有效",
        value: 0
    }
];
/** 权限配置 */ var roleConfig = [
    {
        label: "管理员",
        value: teamInfo/* TeamRoleType.admin */.xO.admin
    },
    {
        label: "成员",
        value: teamInfo/* TeamRoleType.member */.xO.member
    }
];
/**
 * 生成团队邀请链接弹窗
 * ?inviteKey=xxxxxxxx
 */ var InviteModalComp = function InviteModalComp(_ref) {
    var _roleConfig$find;
    var entrance = _ref.entrance, onClose = _ref.onClose, onOpenVipModal = _ref.onOpenVipModal, onTrack = _ref.onTrack;
    var _useState = (0,react.useState)(""), _useState2 = _slicedToArray(_useState, 2), inviteUrl = _useState2[0], setInviteUrl = _useState2[1];
    var inviteId = (0,react.useRef)(0);
    var _useState3 = (0,react.useState)(false), _useState4 = _slicedToArray(_useState3, 2), isCopy = _useState4[0], setIsCopy = _useState4[1];
    // 目前改为30天有效期，且不支持选择
    var _useState5 = (0,react.useState)(expiredConfig[1].value), _useState6 = _slicedToArray(_useState5, 2), expired = _useState6[0], _ = _useState6[1];
    var _useState7 = (0,react.useState)(roleConfig[1].value), _useState8 = _slicedToArray(_useState7, 2), role = _useState8[0], setRole = _useState8[1];
    var _useState9 = (0,react.useState)(false), _useState10 = _slicedToArray(_useState9, 2), __ = _useState10[0], setOpenSelectExpired = _useState10[1];
    var _useState11 = (0,react.useState)(false), _useState12 = _slicedToArray(_useState11, 2), openSelectRole = _useState12[0], setOpenSelectRole = _useState12[1];
    var _useState13 = (0,react.useState)(null), _useState14 = _slicedToArray(_useState13, 2), remaingNum = _useState14[0], setRemaingNum = _useState14[1];
    var isGenerate = (0,react.useRef)(false);
    var teamInfo = (0,dist_teamInfo/* useTeamInfoState */.fM)();
    var hasFetchTeamInfo = (0,dist_teamInfo/* useHasFetchTeamInfoState */.Yr)();
    var isFreeTeam = (0,dist_teamInfo/* checkTeamStatusIsFree */.rM)(teamInfo);
    var popupClickTrack = function popupClickTrack(className) {
        onTrack === null || onTrack === void 0 ? void 0 : onTrack("popup_click", {
            popup_type: "invite",
            entrance: entrance,
            class: className
        });
    };
    // 关闭
    var closeHandle = function closeHandle() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        popupClickTrack("cancel");
    };
    var copyHandle = function copyHandle() {
        if (!inviteUrl) return;
        navigator.clipboard.writeText(inviteUrl);
        setIsCopy(true);
        popupClickTrack("copy_link");
    };
    (0,react.useEffect)(function() {
        onTrack === null || onTrack === void 0 ? void 0 : onTrack("popup_show", {
            popup_type: "invite",
            entrance: entrance
        });
    }, []);
    (0,react.useEffect)(function() {
        if (!hasFetchTeamInfo) return;
        if (isGenerate.current) return;
        isGenerate.current = true;
        var teamInfo = (0,dist_teamInfo/* getTeamInfo */.Iu)();
        (0,api/* generateInvite */.tc)({
            expired_days: expired,
            role: role,
            entrance: entrance,
            teamInfo: teamInfo
        }).then(function(res) {
            var _teamInfo$identity$li, _teamInfo$identity$li2;
            inviteId.current = res.id;
            var name = (_teamInfo$identity$li = teamInfo === null || teamInfo === void 0 ? void 0 : (_teamInfo$identity$li2 = teamInfo.identity.list.find(function(item) {
                return item.oid === teamInfo.identity.oid;
            })) === null || _teamInfo$identity$li2 === void 0 ? void 0 : _teamInfo$identity$li2.name) !== null && _teamInfo$identity$li !== void 0 ? _teamInfo$identity$li : "";
            var inviteUrl = getSharedUrlWidthText({
                shareUrl: res.shortUrl,
                name: name,
                type: "invite"
            });
            setInviteUrl(inviteUrl);
            setRemaingNum(res.seat.remaing);
        }).catch(function() {
            isGenerate.current = false;
        });
    }, [
        expired,
        role,
        hasFetchTeamInfo
    ]);
    function changeInviteHandle(args) {
        if (inviteId.current) {
            (0,api/* generateInvite */.tc)(_objectSpread({
                id: inviteId.current,
                entrance: entrance,
                teamInfo: (0,dist_teamInfo/* getTeamInfo */.Iu)()
            }, args));
        }
    }
    /** 打开团队首次购买会员/续费场景 */ var openVipTeamNormalModal = function openVipTeamNormalModal(args) {
        return onOpenVipModal === null || onOpenVipModal === void 0 ? void 0 : onOpenVipModal(_objectSpread(_objectSpread({}, args), {}, {
            purchase_scene: "normal",
            oid: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.oid,
            groupId: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.groupId
        }));
    };
    /** 打开团队加购席位 */ var openVipTeamExtraModal = function openVipTeamExtraModal(args) {
        return onOpenVipModal === null || onOpenVipModal === void 0 ? void 0 : onOpenVipModal(_objectSpread(_objectSpread({}, args), {}, {
            purchase_scene: "extra",
            subscribe_type: "subscription",
            oid: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.oid,
            groupId: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.groupId
        }));
    };
    // 接口数据还没返回时, 不显示, 防止组件样式严重闪烁
    if (remaingNum === null) return /*#__PURE__*/ react.createElement(react.Fragment, null);
    if (remaingNum === 0) {
        var _teamInfo$member$team, _teamInfo$member;
        return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
            visible: true,
            title: isFreeTeam ? "免费版最多支持".concat((_teamInfo$member$team = teamInfo === null || teamInfo === void 0 ? void 0 : (_teamInfo$member = teamInfo.member) === null || _teamInfo$member === void 0 ? void 0 : _teamInfo$member.team.member_detail.valid_num) !== null && _teamInfo$member$team !== void 0 ? _teamInfo$member$team : 0, "名成员") : "会员席位不足",
            onClose: onClose,
            actionProps: {
                actions: [
                    {
                        style: {
                            background: "var(--background-btn-svip)",
                            // css变量有问题，暂时用硬编码
                            color: "#653619",
                            fontWeight: 500
                        },
                        text: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
                            name: "VipBoldFill",
                            fontSize: 12,
                            style: {
                                marginRight: 4
                            }
                        }), isFreeTeam ? "升级团队版" : "加购席位"),
                        onPress: function onPress() {
                            (isFreeTeam ? openVipTeamNormalModal : openVipTeamExtraModal)({
                                entrance: "popup",
                                second_source: "upper_limit"
                            });
                            onClose === null || onClose === void 0 ? void 0 : onClose();
                            popupClickTrack("add_seat");
                        }
                    }
                ]
            }
        }, /*#__PURE__*/ react.createElement("div", {
            style: {
                marginTop: 8,
                color: "var(--content-system-tertiary, #939599)",
                textAlign: "center",
                fontFamily: "PingFang SC",
                fontSize: 14,
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "20px"
            }
        }, isFreeTeam ? "若需提高席位上限可升级团队版" : "若需继续邀请成员请先加购席位"));
    }
    return /*#__PURE__*/ react.createElement(commonModal/* default */.Z, {
        destroyOnClose: true,
        open: true,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceInviteModal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "Widget teamSpaceInviteModal",
        onClick: function onClick() {
            setOpenSelectExpired(false);
            setOpenSelectRole(false);
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "close",
        onClick: closeHandle
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "header"
    }, "邀请成员"), /*#__PURE__*/ react.createElement("div", {
        className: "seat"
    }, "您还可以", (0,dist_teamInfo/* checkTeamStatusIsFree */.rM)(teamInfo) ? "免费" : "", "邀请", " ", /*#__PURE__*/ react.createElement("span", null, remaingNum, "个"), " 成员加入团队"), /*#__PURE__*/ react.createElement("div", {
        className: "rights"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "right-item"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "ShareBold",
        fontSize: 16,
        color: "var(--content-system-secondary, #616366)"
    }), "一起分享设计成果和素材"), /*#__PURE__*/ react.createElement("div", {
        className: "right-item"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "VipBold",
        fontSize: 16,
        color: "var(--content-system-secondary, #616366)"
    }), "一起共享会员和AI生成额度（美豆）")), /*#__PURE__*/ react.createElement("div", {
        className: "divider"
    }), /*#__PURE__*/ react.createElement("div", {
        className: "member-rights"
    }, "受邀用户的权限：", /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("role", {
            active: openSelectRole
        }),
        onClick: function onClick(e) {
            e.stopPropagation();
            setOpenSelectExpired(false);
            setOpenSelectRole(!openSelectRole);
        }
    }, (_roleConfig$find = roleConfig.find(function(v) {
        return v.value === role;
    })) === null || _roleConfig$find === void 0 ? void 0 : _roleConfig$find.label, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 10,
        name: "ChevronDownBlack",
        color: "var(--content-input-lable)"
    }), openSelectRole ? /*#__PURE__*/ react.createElement("div", {
        className: "select select-role"
    }, roleConfig.map(function(item, index) {
        return /*#__PURE__*/ react.createElement("div", {
            key: index,
            className: classnames_default()("item", {
                active: item.value === role
            }),
            onClick: function onClick(e) {
                e.stopPropagation();
                setRole(item.value);
                setOpenSelectRole(false);
                changeInviteHandle({
                    role: item.value
                });
                popupClickTrack("identity");
            }
        }, item.label);
    })) : null)), /*#__PURE__*/ react.createElement("div", {
        className: "body"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "urlBox"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "url",
        onClick: function onClick() {
            return copyHandle();
        }
    }, inviteUrl)), /*#__PURE__*/ react.createElement("div", {
        className: "btns"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "copy",
        onClick: function onClick() {
            return copyHandle();
        }
    }, isCopy ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 16,
        name: "CheckCircleFillBold",
        color: "#ffffff"
    }), /*#__PURE__*/ react.createElement("span", null, "已复制")) : "复制链接")))));
};
InviteModalComp.displayName = "InviteModalComp";
var InviteModalWithPermission = function InviteModalWithPermission(props) {
    var _usePermissions = (0,usePermissions/* default */.Z)(), permissions = _usePermissions.permissions, loading = _usePermissions.loading;
    var hasInvitePermission = !(0,utils/* isSSO */.yf)() && permissions["member.invite"];
    (0,react.useEffect)(function() {
        if (loading) return;
        if (!hasInvitePermission) {
            message/* default.error */.Z.error("只有团队所有者/管理员可以邀请，您暂时没有权限邀请他人加入团队");
        }
    }, [
        loading,
        hasInvitePermission
    ]);
    if (loading) return null;
    if (!loading && !hasInvitePermission) return null;
    return /*#__PURE__*/ react.createElement(InviteModalComp, props);
};
InviteModalWithPermission.displayName = "InviteModalWithPermission";
var _createModalComponent = (0,createModalComponent/* default */.Z)(InviteModalWithPermission), openInviteModal = _createModalComponent.open;
/** 控制身份切换导致页面刷新后，自动打开邀请弹窗 */ 
var InviteModalAfterReload = /*#__PURE__*/ function() {
    function InviteModalAfterReload() {
        _classCallCheck(this, InviteModalAfterReload);
    }
    _createClass(InviteModalAfterReload, null, [
        {
            key: "init",
            value: /** 初始化, 用于在页面加载时, 自动打开邀请弹窗 */ function init(params) {
                if (this.isInit) return;
                this.isInit = true;
                var recordParams = window.localStorage.getItem(this.LOCAL_STORAGE_KEY);
                window.localStorage.removeItem(this.LOCAL_STORAGE_KEY);
                if (recordParams !== null) {
                    var recordParamsObj = JSON.parse(recordParams);
                    openInviteModal(_objectSpread(_objectSpread({}, recordParamsObj), params));
                }
            }
        },
        {
            key: "prepareOpen",
            value: function prepareOpen(params) {
                if ((0,utils/* isSSO */.yf)() || (0,dist_teamInfo/* isFromZhanKu */.b6)()) return;
                window.localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(params));
            }
        }
    ]);
    return InviteModalAfterReload;
}();
inviteModal_defineProperty(InviteModalAfterReload, "isInit", false);
inviteModal_defineProperty(InviteModalAfterReload, "LOCAL_STORAGE_KEY", "invite_modal_after_reload");
var useOpenInviteModalFromQuery = function useOpenInviteModalFromQuery() {
    var QUERY_KEY = "openInviteModal";
    var QUERY_KEY_ENTRANCE = "openInviteModalEntrance";
    var init = function init(params) {
        if ((0,url/* getQueryParam */.Ph)(QUERY_KEY) === "1") {
            var entrance = (0,url/* getQueryParam */.Ph)(QUERY_KEY_ENTRANCE);
            (0,url/* deleteQueryParams */.Ow)(QUERY_KEY);
            (0,url/* deleteQueryParams */.Ow)(QUERY_KEY_ENTRANCE);
            openInviteModal({
                entrance: entrance,
                onTrack: params.onTrack,
                onOpenVipModal: params.onOpenVipModal
            });
        }
    };
    var reloadAndOpenInviteModal = function reloadAndOpenInviteModal() {
        var _appendQueryParams;
        var entrance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "auto_pop";
        if ((0,utils/* isSSO */.yf)() || (0,dist_teamInfo/* isFromZhanKu */.b6)()) return;
        // TODO: 未来changeIdentity url改造
        (0,url/* appendQueryParams */.DZ)((_appendQueryParams = {}, inviteModal_defineProperty(_appendQueryParams, QUERY_KEY, 1), inviteModal_defineProperty(_appendQueryParams, QUERY_KEY_ENTRANCE, entrance), _appendQueryParams));
        window.location.reload();
    };
    return {
        init: init,
        reloadAndOpenInviteModal: reloadAndOpenInviteModal
    };
};


/***/ }),

/***/ 30938:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10275);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46718);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97303);
/* harmony import */ var _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77724);
/* harmony import */ var _confirmModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69868);
/* harmony import */ var _expiredModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40769);
/* harmony import */ var _freezeModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72715);
/* harmony import */ var _inviteModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56157);
/* harmony import */ var _loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65229);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}










var instance = null;
/** 团队弹窗 */ var TeamInfoModal = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(_ref) {
    var _switchModalOpenArgs$;
    var disabledMask = _ref.disabledMask, _ref$isTeamHome = _ref.isTeamHome, isTeamHome = _ref$isTeamHome === void 0 ? false : _ref$isTeamHome, confirmPopupDesc = _ref.confirmPopupDesc, maskStyle = _ref.maskStyle, create_team_success_entrance = _ref.create_team_success_entrance, onDiff = _ref.onDiff, onChange = _ref.onChange, onOpenVipModal = _ref.onOpenVipModal, onCheckTeamOtherStatus = _ref.onCheckTeamOtherStatus, onTrack = _ref.onTrack;
    var _useOpenInviteModalFr = (0,_inviteModal__WEBPACK_IMPORTED_MODULE_2__/* .useOpenInviteModalFromQuery */ .ce)(), initOpenInviteModalFromQuery = _useOpenInviteModalFr.init;
    var _useConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .useConfig */ .ZR)(), isTeam = _useConfig.isTeam;
    var teamInfo = (0,___WEBPACK_IMPORTED_MODULE_4__/* .useTeamInfoState */ .fM)();
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        open: false,
        type: null
    }), _useState2 = _slicedToArray(_useState, 2), mask = _useState2[0], setMask = _useState2[1];
    var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), _useState4 = _slicedToArray(_useState3, 2), switchModalStatus = _useState4[0], setSwitchModalStatus = _useState4[1];
    var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), _useState6 = _slicedToArray(_useState5, 2), confirmStatus = _useState6[0], setConfirmStatus = _useState6[1];
    var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), _useState8 = _slicedToArray(_useState7, 2), newOid = _useState8[0], setNewOid = _useState8[1];
    var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), _useState10 = _slicedToArray(_useState9, 2), newGroupId = _useState10[0], setNewGroupId = _useState10[1];
    var changeStatusRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var isFirstRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(true);
    var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), _useState12 = _slicedToArray(_useState11, 2), switchModalOpenArgs = _useState12[0], setSwitchModalOpenArgs = _useState12[1];
    var _useConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .useConfig */ .ZR)(), userInfo = _useConfig2.userInfo;
    var openExpired = function openExpired() {
        (0,___WEBPACK_IMPORTED_MODULE_4__/* .openTeamExpiredPopup */ .kA)({
            entrance: "popup_window",
            onOK: function onOK(entrance) {
                onOpenVipModal === null || onOpenVipModal === void 0 ? void 0 : onOpenVipModal({
                    entrance: entrance,
                    oid: (teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.oid) || 0,
                    groupId: (teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.groupId) || 0,
                    purchase_scene: "normal",
                    subscribe_type: "subscription"
                });
            },
            onTrack: onTrack
        });
    };
    var openFreeze = function openFreeze() {
        (0,___WEBPACK_IMPORTED_MODULE_4__/* .openTeamFreezePopup */ .Gl)({
            entrance: "popup_window",
            onTrack: onTrack
        });
    };
    var clearPopup = function clearPopup() {
        (0,___WEBPACK_IMPORTED_MODULE_4__/* .closeTeamFreezePopup */ .I3)();
        (0,___WEBPACK_IMPORTED_MODULE_4__/* .closeTeamExpiredPopup */ .Qn)();
        setMask({
            open: false,
            type: null
        });
    };
    // 触发业务身份切换逻辑
    var handleChange = /*#__PURE__*/ function() {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(oid, groupId) {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
                while(1)switch(_context.prev = _context.next){
                    case 0:
                        onChange === null || onChange === void 0 ? void 0 : onChange(oid, groupId);
                    case 1:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function handleChange(_x2, _x3) {
            return _ref2.apply(this, arguments);
        };
    }();
    /**
   * 用户信息接口和团队信息接口并发请求
   * 如果用户信息接口先返回，则有uid，会重新再次触发团队信息接口，这时需要等第一次团队信息接口响应返回后再决定，如果有值则取消请求
   * @param userId
   */ var handleFetchTeamInfo = /*#__PURE__*/ function() {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(userId) {
            var teamInfoData;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(1)switch(_context2.prev = _context2.next){
                    case 0:
                        teamInfoData = (0,___WEBPACK_IMPORTED_MODULE_4__/* .getTeamInfo */ .Iu)();
                        if (!teamInfoData) {
                            _context2.next = 3;
                            break;
                        }
                        return _context2.abrupt("return");
                    case 3:
                        _context2.prev = 3;
                        if (!instance) {
                            _context2.next = 9;
                            break;
                        }
                        _context2.next = 7;
                        return instance;
                    case 7:
                        _context2.next = 11;
                        break;
                    case 9:
                        _context2.next = 11;
                        return instance = (0,___WEBPACK_IMPORTED_MODULE_4__/* .fetchTeamInfo */ .mR)();
                    case 11:
                        if (userId && !teamInfoData) {
                            (0,___WEBPACK_IMPORTED_MODULE_4__/* .fetchTeamInfo */ .mR)();
                        }
                    case 12:
                        _context2.prev = 12;
                        instance = null;
                        return _context2.finish(12);
                    case 15:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, null, [
                [
                    3,
                    ,
                    12,
                    15
                ]
            ]);
        }));
        return function handleFetchTeamInfo(_x4) {
            return _ref3.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        initOpenInviteModalFromQuery({
            onOpenVipModal: onOpenVipModal,
            onTrack: onTrack
        });
        _inviteModal__WEBPACK_IMPORTED_MODULE_2__/* .InviteModalAfterReload.init */ .uL.init({
            onOpenVipModal: onOpenVipModal,
            onTrack: onTrack
        });
    }, []);
    // 弹窗阻断
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        clearPopup();
        if (!(teamInfo !== null && teamInfo !== void 0 && teamInfo.member)) return;
        // 团队过期提示
        if ((0,___WEBPACK_IMPORTED_MODULE_4__/* .checkTeamIsEnterprise */ .Yt)(teamInfo) && !(0,___WEBPACK_IMPORTED_MODULE_4__/* .checkTeamStatusIsVip */ .zb)(teamInfo)) {
            openExpired();
            (0,___WEBPACK_IMPORTED_MODULE_4__/* .closeTeamFreezePopup */ .I3)();
            setMask({
                open: true,
                type: "expired"
            });
            return;
        }
        // 席位冻结 or 当前用户没有席位
        if ((0,___WEBPACK_IMPORTED_MODULE_4__/* .checkUserSeatIsFreeze */ .vn)(teamInfo) || !(0,___WEBPACK_IMPORTED_MODULE_4__/* .checkUserHasSeat */ .gS)(teamInfo)) {
            openFreeze();
            (0,___WEBPACK_IMPORTED_MODULE_4__/* .closeTeamExpiredPopup */ .Qn)();
            setMask({
                open: true,
                type: "freeze"
            });
            return;
        }
        onCheckTeamOtherStatus === null || onCheckTeamOtherStatus === void 0 ? void 0 : onCheckTeamOtherStatus();
    }, [
        teamInfo
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // 页面第一次加载, uid=0，需要默认加载团队接口
        // 非页面第一次加载且退出登录操作时uid=0，此时已经调用 clearTeamInfo清空团队信息，不需要重新调用接口
        if (!isTeam || !userInfo.id && !isFirstRef.current) return;
        handleFetchTeamInfo(userInfo.id);
        isFirstRef.current = false;
    }, [
        userInfo.id
    ]);
    // 弹出身份选择
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var changeHandle = function changeHandle() {
            onDiff === null || onDiff === void 0 ? void 0 : onDiff();
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].addListener */ .Z.addListener(___WEBPACK_IMPORTED_MODULE_4__/* .CHANGE_TEAM_OID */ .Uy, changeHandle);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].removeListener */ .Z.removeListener(___WEBPACK_IMPORTED_MODULE_4__/* .CHANGE_TEAM_OID */ .Uy, changeHandle);
        };
    }, [
        onDiff
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .addStorageChangeListener */ .lQ)(function(oid, groupId) {
            // 已经提示中了或者未登录态下，不需要触发业务的onChange回调
            if (changeStatusRef.current || !(0,___WEBPACK_IMPORTED_MODULE_4__/* .getIdentityChangeListenerStatus */ .gm)() || !isTeam) return;
            changeStatusRef.current = true;
            if (!(0,___WEBPACK_IMPORTED_MODULE_4__/* .getIsSwitchIdentityInitiative */ .$v)()) {
                // 非激活态tab页面属于被动提示身份切换
                setNewOid(oid);
                setNewGroupId(groupId);
                setConfirmStatus(true);
            } else {
                // 激活态页面，主动切换身份，不需要提示弹窗
                handleChange(oid, groupId);
            }
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isTeam) {
            (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .disableTeamIdentity */ .Yb)();
        } else {
            (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_0__/* .enableTeamIdentity */ .lD)();
        }
    }, [
        isTeam
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var onOpen = function onOpen(data) {
            if (!isTeam) return;
            setSwitchModalStatus(true);
            setSwitchModalOpenArgs(data);
        };
        var onClose = function onClose() {
            if (!isTeam) return;
            setSwitchModalStatus(false);
            setSwitchModalOpenArgs({});
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].addListener */ .Z.addListener(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_6__/* .SHOW_IDENTITY_SWITCH_MODAL */ .Mg, onOpen);
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].addListener */ .Z.addListener(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_6__/* .HIDDEN_IDENTITY_SWITCH_MODAL */ .BM, onClose);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].removeListener */ .Z.removeListener(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_6__/* .SHOW_IDENTITY_SWITCH_MODAL */ .Mg, onOpen);
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_5__/* ["default"].removeListener */ .Z.removeListener(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_6__/* .HIDDEN_IDENTITY_SWITCH_MODAL */ .BM, onClose);
        };
    }, []);
    if (!isTeam) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, !isTeamHome && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_expiredModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        identityList: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list
    }), !isTeamHome && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_freezeModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, null), confirmStatus && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_confirmModal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        description: confirmPopupDesc,
        onOk: function onOk() {
            setConfirmStatus(false);
            handleChange(newOid, newGroupId);
        }
    }), switchModalStatus && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, _extends({}, switchModalOpenArgs, {
        create_team_success_entrance: (_switchModalOpenArgs$ = switchModalOpenArgs.create_team_success_entrance) !== null && _switchModalOpenArgs$ !== void 0 ? _switchModalOpenArgs$ : create_team_success_entrance,
        onClose: function onClose() {
            setSwitchModalStatus(false);
            setSwitchModalOpenArgs({});
        },
        onTrack: onTrack
    })), !isTeamHome && !disabledMask && mask.open && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        style: _objectSpread({
            position: "fixed",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 999
        }, maskStyle || {}),
        onClick: function onClick() {
            switch(mask.type){
                case "expired":
                    openExpired();
                    break;
                case "freeze":
                    openFreeze();
                    break;
            }
        }
    }));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TeamInfoModal);


/***/ }),

/***/ 90076:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46718);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37057);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}



var cachedOperatePermission = null;
var promise = null;
var usePermissions = function usePermissions() {
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        "team.info": false,
        "team.update": false,
        "team.pay": false,
        "team.unregister": false,
        "data.summary": false,
        "member.list": false,
        "member.invite": false,
        "member.change_role": false,
        "member.remove": false,
        "order.list": false,
        "order.make_invoice": false,
        "accredit.list": false,
        "accredit.create": false
    }), _useState2 = _slicedToArray(_useState, 2), permissions = _useState2[0], setPermissions = _useState2[1];
    var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), _useState4 = _slicedToArray(_useState3, 2), loading = _useState4[0], setLoading = _useState4[1];
    var hasFetchTeamInfo = (0,___WEBPACK_IMPORTED_MODULE_1__/* .useHasFetchTeamInfoState */ .Yr)();
    var isTeam = (0,___WEBPACK_IMPORTED_MODULE_1__/* .checkIsTeam */ .hU)((0,___WEBPACK_IMPORTED_MODULE_1__/* .useTeamInfoState */ .fM)());
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!hasFetchTeamInfo) return;
        if (!isTeam) {
            setLoading(false);
            return;
        }
        if (cachedOperatePermission) {
            setPermissions(cachedOperatePermission);
            setLoading(false);
            return;
        }
        if (!promise) promise = (0,_api__WEBPACK_IMPORTED_MODULE_2__/* .fetchMemberPermission */ .bE)();
        promise.then(function(keys) {
            var res = keys.reduce(function(acc, key) {
                acc[key] = true;
                return acc;
            }, {});
            setPermissions(res);
            cachedOperatePermission = res;
            promise = null;
            setLoading(false);
        }).catch(function() {
            setLoading(false);
        });
    }, [
        hasFetchTeamInfo,
        isTeam
    ]);
    return {
        permissions: permissions,
        loading: loading
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (usePermissions);


/***/ }),

/***/ 86984:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": () => (/* binding */ appendQueryParams),
/* harmony export */   "Ow": () => (/* binding */ deleteQueryParams),
/* harmony export */   "Ph": () => (/* binding */ getQueryParam)
/* harmony export */ });
/* unused harmony exports getTopLevelDomain, getQuery, stringifyQuery, parseQueryString, getNewUrl */
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/* eslint-disable @typescript-eslint/no-use-before-define */ 

function getTopLevelDomain() {
    var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
    var parts = hostname.split(".").reverse();
    if (parts[0] === "localhost") {
        return "x-design.com";
    } else {
        return parts[1] + "." + parts[0];
    }
}
/**
 * 获取地址参数对象
 * @return
 */ var getQuery = function getQuery() {
    if (true) {
        return parseQueryString(window.location.search);
    }
    return {};
};
function stringifyQuery(params) {
    var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(params, sort ? {
        sort: function sort(a, b) {
            return a.localeCompare(b);
        }
    } : undefined);
}
function parseQueryString(query) {
    // Remove any leading '?' from the query string
    if (query.startsWith("?")) {
        query = query.slice(1);
    }
    return qs__WEBPACK_IMPORTED_MODULE_1___default().parse(query);
}
/**
 * 获取指定的参数
 * @param key
 * @param defaultValue
 * @param query
 * @return
 */ var getQueryParam = function getQueryParam(key, defaultValue, query) {
    if (true) {
        var q = query || getQuery();
        return q[key] || defaultValue;
    }
    return "";
};
var filterEmpty = function filterEmpty(trackObj) {
    Object.keys(trackObj).forEach(function(key) {
        var val = trackObj[key];
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.isUndefined)(val)) {
            delete trackObj[key];
        }
    });
    return trackObj;
};
/**
 * 替换url地址
 * @param params
 */ function replaceLocation(params) {
    var query = getQuery();
    var finalQuery = filterEmpty(_objectSpread(_objectSpread({}, query), params));
    window.history.replaceState({}, "", getNewUrl(finalQuery));
}
/**
 * 向地址栏追加参数
 * @param params
 * @param replace 参数存在，是否替换
 */ var appendQueryParams = function appendQueryParams(params) {
    var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var query = getQuery();
    Object.keys(params).forEach(function(key) {
        var val = params[key];
        if (replace) {
            query[key] = val;
        } else {
            if (!query[key]) {
                query[key] = val;
            }
        }
    });
    replaceLocation(query);
};
/**
 * 移除URL链接上的参数
 * @param params {string[] | string} 参数名称
 */ var deleteQueryParams = function deleteQueryParams(params) {
    var query = getQuery();
    if (Array.isArray(params)) {
        params.forEach(function(key) {
            delete query[key];
        });
    } else {
        delete query[params];
    }
    window.history.replaceState({}, "", getNewUrl(query));
};
/**
 * 获取当前path下，指定参数的新地址
 * @param params
 * @returns
 */ function getNewUrl(params) {
    var queryStr = stringifyQuery(params);
    return "".concat(window.location.origin).concat(window.location.pathname).concat(queryStr ? "?" + queryStr : "");
}


/***/ }),

/***/ 69289:
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ dist_createModalComponent)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/React/render.js
var React_render = __webpack_require__(24996);
;// CONCATENATED MODULE: ./node_modules/react-modal-open/dist/renderPromise.js


var renderPromise = function renderPromise(node, container) {
    return new Promise(function(resolve) {
        var Root = function Root(_ref) {
            var onMount = _ref.onMount, children = _ref.children;
            (0,react.useEffect)(function() {
                onMount();
            }, []);
            return /*#__PURE__*/ react.createElement(react.Fragment, null, children);
        };
        (0,React_render/* render */.sY)(/*#__PURE__*/ react.createElement(Root, {
            onMount: resolve
        }, node), container);
    });
};
/* harmony default export */ const dist_renderPromise = (renderPromise);

;// CONCATENATED MODULE: ./node_modules/react-modal-open/dist/createModalComponent.js
/* module decorator */ module = __webpack_require__.hmd(module);
function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
}
var _excluded = [
    "onClose"
];
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var createRef = function createRef(v) {
    return {
        current: v
    };
};
/**
 * @example
 * // MyModal.tsx
 * const MyModal: React.FC<{ onClose?: () => void; }> = ({
 *   onClose,
 * }) => (
 *   <div>
 *     <button onClick={onClose}>close</button>
 *     MyModal
 *   </div>
 * );
 *
 * export const MyModalComponent = createModalComponent(MyModal);
 *
 * // App.tsx
 * import { MyModalComponent } from './MyModal';
 *
 * (async () => {
 *   const closeMyModal = await MyModalComponent.open();
 *   setTimeout(() => {
 *     closeMyModal();
 *   }, 3000);
 * })();
 */ function createModalComponent(Modal, cfg) {
    var singletonElRef = createRef(null);
    var ModalComponent = Modal;
    ModalComponent.open = /*#__PURE__*/ function() {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(props) {
            var elRef, _ref2, _onClose, restProps, rmModal, render, _module$hot;
            return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(1)switch(_context2.prev = _context2.next){
                    case 0:
                        elRef = cfg !== null && cfg !== void 0 && cfg.singleton ? singletonElRef : createRef(null);
                        _ref2 = props !== null && props !== void 0 ? props : {}, _onClose = _ref2.onClose, restProps = _objectWithoutProperties(_ref2, _excluded);
                        if (!elRef.current) {
                            elRef.current = document.createElement("div");
                        }
                        document.body.appendChild(elRef.current);
                        rmModal = function rmModal() {
                            if (elRef.current && elRef.current.parentNode) {
                                (0,React_render/* unmount */.vE)(elRef.current);
                                elRef.current.parentNode.removeChild(elRef.current);
                                elRef.current = null;
                            }
                        };
                        render = /*#__PURE__*/ function() {
                            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
                                return _regeneratorRuntime().wrap(function _callee$(_context) {
                                    while(1)switch(_context.prev = _context.next){
                                        case 0:
                                            if (elRef.current) {
                                                _context.next = 2;
                                                break;
                                            }
                                            return _context.abrupt("return");
                                        case 2:
                                            _context.next = 4;
                                            return dist_renderPromise(/*#__PURE__*/ // @ts-ignore
                                            react.createElement(Modal, _extends({}, restProps, {
                                                onClose: function onClose() {
                                                    setTimeout(function() {
                                                        rmModal();
                                                    });
                                                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                                        args[_key] = arguments[_key];
                                                    }
                                                    return _onClose === null || _onClose === void 0 ? void 0 : _onClose(args);
                                                }
                                            })), elRef.current);
                                        case 4:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            return function render() {
                                return _ref3.apply(this, arguments);
                            };
                        }();
                        render();
                        try {
                            (_module$hot = module.hot) === null || _module$hot === void 0 ? void 0 : _module$hot.addStatusHandler(function(status) {
                                if (status === "idle") {
                                    render();
                                }
                            });
                        } catch (_unused) {
                        /* eslint no-empty:off */ }
                        return _context2.abrupt("return", rmModal);
                    case 9:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
    return ModalComponent;
}
/* harmony default export */ const dist_createModalComponent = (createModalComponent);


/***/ }),

/***/ 41004:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 58322:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 21385:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ })

}]);